import DashboardHome from "../../components/DashboardHome/DashboardHome";

function DealershipHome() {
  return <DashboardHome />;
}

export default DealershipHome;
